import { DELETE_FOUNDERS_START } from '../../types';

export const delete_founders = (payload) => ({
  type: DELETE_FOUNDERS_START,
  payload,
});
